import React, { useRef, useEffect } from 'react';
import { outlineTexts } from '../contexts/Lang1K';
import faceIcon from '../assets/images/1kosmos/facemask.png';

function Product1KOutline({ lang = 'ko', isMobile = false }) {
  return (
    <div
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: '#3a3570',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '0 10px' : '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.6rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 12 : 16,
        paddingLeft: isMobile ? 20 : 40,
        paddingRight: isMobile ? 20 : 0,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        lineHeight: 1.3,
        textAlign: 'center', // 가운데 정렬 추가
        width: '100%'        // 부모 div 기준으로 가운데 정렬 적용

      }}>
        {outlineTexts.title[lang]}
      </span>
      <div
        className="outline-flex"
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          width: '100%',
          padding: isMobile ? '20px 20px 32px 20px' : '24px 40px 32px 40px',
          boxSizing: 'border-box',
          gap: isMobile ? 24 : 0
        }}
      >
        {/* 왼쪽 박스 */}
        <div style={{
          flex: isMobile ? 'none' : 1,
          width: isMobile ? '100%' : 'auto',
          fontSize: isMobile ? '1rem' : '1.15rem',
          color: '#fff',
          fontWeight: 500,
          lineHeight: 1.7,
          paddingRight: isMobile ? 0 : 32,
          textAlign: isMobile ? 'center' : 'left'
        }}>
          <span style={{
            fontSize: isMobile ? '1.2rem' : '1.35rem',
            fontWeight: 700,
            display: 'block',
            marginBottom: isMobile ? 12 : 8
          }}>
            {outlineTexts.subtitle[lang]}
          </span>
          {outlineTexts.message[lang]}
        </div>
        {/* 오른쪽 박스 - 이미지 + 외곽선 SVG + 카메라 아이콘 */}
        <div style={{
          flex: isMobile ? 'none' : 1,
          width: isMobile ? '100%' : 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: isMobile ? 20 : 32
        }}>
          <OutlineAVI isMobile={isMobile}/>
        </div>
      </div>

    </div>
  );
}

function CameraSVG() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      {/* 카메라 바디 */}
      <rect x="8" y="16" width="32" height="20" rx="4" stroke="#0082C9" strokeWidth="2" fill="white"/>
      {/* 렌즈 */}
      <circle cx="24" cy="26" r="6" stroke="#0082C9" strokeWidth="2" fill="white"/>
      {/* 플래시/뷰파인더 */}
      <rect x="16" y="12" width="16" height="6" rx="2" stroke="#0082C9" strokeWidth="2" fill="white"/>
      {/* 셔터 버튼 */}
      <circle cx="36" cy="14" r="2" fill="#0082C9"/>
    </svg>
  );
}

function FaceSVG() {
  return (
    <img
      src={faceIcon}
      alt="face"
      style={{
        width: 220,
        height: 220,
        objectFit: 'contain',
        display: 'block'
      }}
    />
  );
}

function WalletSVG() {
  return (
    <svg width="220" height="220" viewBox="0 0 48 48" fill="none">
      {/* 지갑 본체 */}
      <rect x="8" y="14" width="32" height="20" rx="4" stroke="#FF9800" strokeWidth="2" fill="#fff"/>
      {/* 잠금 버튼 */}
      <circle cx="38" cy="24" r="5" fill="#FF9800"/>
      {/* 내부 라인 */}
      <rect x="14" y="18" width="10" height="4" rx="2" fill="#FFE0B2"/>
      <rect x="14" y="23" width="10" height="4" rx="2" fill="#FFE0B2"/>
    </svg>
  );
}

function WalletCardSVG() {
  return (
    <svg width="220" height="220" viewBox="0 0 48 48" fill="none">
      {/* 카드 - 네모난 카드 15도 왼쪽으로 기울임 */}
      <rect 
        x="14" 
        y="6" 
        width="20" 
        height="12" 
        rx="2" 
        stroke="#0082C9" 
        strokeWidth="2" 
        fill="#E0F2FB"
        transform="rotate(-15 24 12)"
      />
      {/* 지갑 본체 */}
      <rect x="8" y="14" width="32" height="20" rx="4" stroke="#FF9800" strokeWidth="2" fill="#fff"/>
      {/* 잠금 버튼 */}
      <circle cx="38" cy="24" r="5" fill="#FF9800"/>
      {/* 내부 라인 */}
      <rect x="14" y="18" width="10" height="4" rx="2" fill="#FFE0B2"/>
      <rect x="14" y="23" width="10" height="4" rx="2" fill="#FFE0B2"/>
    </svg>
  );
}

function DriverSVG() {
  return (
    <svg width="220" height="220" viewBox="0 0 48 48" fill="none">
      {/* 면허증 본체 */}
      <rect x="6" y="10" width="36" height="28" rx="4" stroke="#4CAF50" strokeWidth="2" fill="#fff"/>
      {/* 사진 영역 */}
      <rect x="10" y="16" width="10" height="12" rx="2" fill="#B2DFDB" stroke="#4CAF50" strokeWidth="1"/>
      {/* 이름 영역 */}
      <rect x="22" y="16" width="16" height="4" rx="2" fill="#E0E0E0"/>
      {/* 번호 영역 */}
      <rect x="22" y="22" width="16" height="3" rx="1.5" fill="#E0E0E0"/>
      {/* 발급일 영역 */}
      <rect x="22" y="27" width="10" height="3" rx="1.5" fill="#E0E0E0"/>
      {/* 서명 라인 */}
      <line x1="22" y1="32" x2="38" y2="32" stroke="#4CAF50" strokeWidth="1"/>
    </svg>
  );
}

// 애니메이션 컴포넌트
function CardregAni() {
  const driverRef = useRef(null);
  const cameraRef = useRef(null);
  const flashRef = useRef(null);

  // 추가 애니메이션용 ref
  const walletRef = useRef(null);
  const driver2Ref = useRef(null); // CardSVG 대신 DriverSVG로 변경
  const walletCardRef = useRef(null);

  useEffect(() => {
    const driver = driverRef.current;
    const camera = cameraRef.current;
    const flash = flashRef.current;
    const wallet = walletRef.current;
    const driver2 = driver2Ref.current;
    const walletCard = walletCardRef.current;

    // 1단계: DriverSVG, CameraSVG 애니메이션
    driver.style.transform = 'translateX(220px)';
    driver.style.opacity = 0; // 오른쪽 끝에 보이지 않게
    camera.style.transform = 'translateX(-220px)';
    camera.style.opacity = 0; // 왼쪽 끝에 보이지 않게
    flash.style.opacity = 0;

    // 2단계: WalletSVG/DriverSVG/WalletCardSVG 초기 상태
    wallet.style.opacity = 0;
    driver2.style.transform = 'translateX(-220px)';
    driver2.style.opacity = 0;
    walletCard.style.opacity = 0;

    // DriverSVG 중앙으로 이동 및 fade in
    setTimeout(() => {
      driver.style.transition = 'transform 0.7s cubic-bezier(.7,.2,.3,1), opacity 0.7s';
      driver.style.transform = 'translateX(0)';
      driver.style.opacity = 1;
    }, 100);

    // CameraSVG 중앙으로 이동 및 fade in
    setTimeout(() => {
      camera.style.transition = 'transform 0.7s cubic-bezier(.7,.2,.3,1), opacity 0.7s';
      camera.style.transform = 'translateX(0)';
      camera.style.opacity = 1;
    }, 900);

    // 플래시 번쩍임
    setTimeout(() => {
      flash.style.transition = 'opacity 0.2s';
      flash.style.opacity = 1;
    }, 1700);

    setTimeout(() => {
      flash.style.opacity = 0;
    }, 1900);

    // DriverSVG, CameraSVG fade out
    setTimeout(() => {
      driver.style.transition = 'opacity 0.7s';
      camera.style.transition = 'opacity 0.7s';
      driver.style.opacity = 0;
      camera.style.opacity = 0;
    }, 2100);

    // WalletSVG fade in
    setTimeout(() => {
      wallet.style.transition = 'opacity 0.7s';
      wallet.style.opacity = 1;
    }, 2900);

    // DriverSVG 이동 및 fade in (왼쪽에서 WalletSVG 위로 이동)
    setTimeout(() => {
      driver2.style.transition = 'transform 0.7s cubic-bezier(.7,.2,.3,1), opacity 0.7s, top 0.7s, left 0.7s';
      driver2.style.transform = 'translateX(0)';
      driver2.style.opacity = 1;
      driver2.style.top = '0px'; // WalletSVG와 겹치도록 중앙으로 이동
      driver2.style.left = '0px';
    }, 3400);

    // WalletSVG, DriverSVG fade out
    setTimeout(() => {
      wallet.style.transition = 'opacity 0.7s';
      driver2.style.transition = 'opacity 0.7s';
      wallet.style.opacity = 0;
      driver2.style.opacity = 0;
    }, 4100);

    // WalletCardSVG fade in
    setTimeout(() => {
      walletCard.style.transition = 'opacity 0.7s';
      walletCard.style.opacity = 1;
    }, 4700);

    // WalletCardSVG fade out
    setTimeout(() => {
      walletCard.style.transition = 'opacity 0.7s';
      walletCard.style.opacity = 0;
    }, 5400);
  }, []);

  return (
    <div style={{
      position: 'relative',
      width: 220,
      height: 220,
      margin: '0 auto',
      overflow: 'visible'
    }}>
      {/* DriverSVG (첫번째) */}
      <div
        ref={driverRef}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          transition: 'transform 0.7s, opacity 0.7s',
          zIndex: 1
        }}
      >
        <DriverSVG />
      </div>
      {/* CameraSVG */}
      <div
        ref={cameraRef}
        style={{
          position: 'absolute',
          left: 86,
          top: 86,
          transition: 'transform 0.7s, opacity 0.7s',
          zIndex: 2
        }}
      >
        <CameraSVG />
      </div>
      {/* 플래시 효과 */}
      <div
        ref={flashRef}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: 220,
          height: 220,
          background: 'radial-gradient(circle, #fff 60%, transparent 100%)',
          opacity: 0,
          pointerEvents: 'none',
          zIndex: 3
        }}
      />
      {/* WalletSVG */}
      <div
        ref={walletRef}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          opacity: 0,
          transition: 'opacity 0.7s',
          zIndex: 4
        }}
      >
        <WalletSVG />
      </div>
      {/* DriverSVG (두번째, 카드 역할) */}
      <div
        ref={driver2Ref}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          opacity: 0,
          transition: 'transform 0.7s, opacity 0.7s, top 0.7s',
          zIndex: 5
        }}
      >
        <DriverSVG />
      </div>
      {/* WalletCardSVG */}
      <div
        ref={walletCardRef}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          opacity: 0,
          transition: 'opacity 0.7s',
          zIndex: 6
        }}
      >
        <WalletCardSVG />
      </div>
    </div>
  );
}

function FaceregAni() {
  const faceRef = useRef(null);
  const cameraRef = useRef(null);
  const flashRef = useRef(null);

  useEffect(() => {
    const face = faceRef.current;
    const camera = cameraRef.current;
    const flash = flashRef.current;

    // 초기 상태
    face.style.transform = 'translateX(220px)';
    face.style.opacity = 1;
    camera.style.transform = 'translateX(-220px)';
    camera.style.opacity = 0;
    flash.style.opacity = 0;

    // FaceSVG 이동
    setTimeout(() => {
      face.style.transition = 'transform 0.7s cubic-bezier(.7,.2,.3,1)';
      face.style.transform = 'translateX(0)';
    }, 100);

    // CameraSVG 이동 및 fade in
    setTimeout(() => {
      camera.style.transition = 'transform 0.7s cubic-bezier(.7,.2,.3,1), opacity 0.7s';
      camera.style.transform = 'translateX(0)';
      camera.style.opacity = 1;
    }, 900);

    // 플래시 번쩍임
    setTimeout(() => {
      flash.style.transition = 'opacity 0.2s';
      flash.style.opacity = 1;
    }, 1700);

    setTimeout(() => {
      flash.style.opacity = 0;
    }, 1900);

    // FaceSVG, CameraSVG fade out
    setTimeout(() => {
      face.style.transition = 'opacity 0.7s';
      camera.style.transition = 'opacity 0.7s';
      face.style.opacity = 0;
      camera.style.opacity = 0;
    }, 2100);
  }, []);

  return (
    <div style={{
      position: 'relative',
      width: 220,
      height: 220,
      margin: '0 auto',
      overflow: 'visible'
    }}>
      {/* FaceSVG */}
      <div
        ref={faceRef}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          transition: 'transform 0.7s, opacity 0.7s',
          zIndex: 1
        }}
      >
        <FaceSVG />
      </div>
      {/* CameraSVG */}
      <div
        ref={cameraRef}
        style={{
          position: 'absolute',
          left: 86,
          top: 86,
          transition: 'transform 0.7s, opacity 0.7s',
          zIndex: 2
        }}
      >
        <CameraSVG />
      </div>
      {/* 플래시 효과 */}
      <div
        ref={flashRef}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: 220,
          height: 220,
          background: 'radial-gradient(circle, #fff 60%, transparent 100%)',
          opacity: 0,
          pointerEvents: 'none',
          zIndex: 3
        }}
      />
    </div>
  );
}

function OutlineAni() {
  const [play, setPlay] = React.useState(false);

  return (
    <div
      style={{
        width: 220,
        height: 220,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      }}
      onMouseEnter={() => setPlay(true)}
      onMouseLeave={() => setPlay(false)}
    >
      {play ? <CardregAni />: <FaceSVG />}
    </div>
  );
}

function OutlineAVI({ isMobile = false }) {
  return (
    <div
      style={{
        width: isMobile ? '100%' : 620,
        maxWidth: isMobile ? '400px' : '620px',
        height: isMobile ? 'auto' : 349,
        aspectRatio: isMobile ? '16/9' : 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 12,
        overflow: 'hidden',
        background: '#000',
        padding: 0
      }}
    >
      <iframe
        src="https://player.vimeo.com/video/848372188"
        width="100%"
        height="100%"
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        title="Vimeo Video"
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
          border: 'none',
          objectFit: 'cover'
        }}
      />
    </div>
  );
}

export default Product1KOutline;